"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhaethonApi = void 0;
const _ = require("lodash");
const env_1 = require("../../conf/env");
const qs = require("querystring");
const base_api_1 = require("./base-api");
/**
 * @description api services for Phaethon api endpoints
 *
 * @export
 * @class PhaethonApi
 * @extends {BaseApi<T>}
 * @template T
 */
class PhaethonApi extends base_api_1.BaseApi {
    constructor(apiKey, authToken, domainPermissionToken) {
        const axiosConfig = {
            baseURL: env_1.PHAETHON_API_URL,
            headers: {
                "API-KEY": apiKey
            },
            timeout: 20000
        };
        if (authToken && domainPermissionToken)
            _.extend(axiosConfig.headers, {
                Authorization: `Bearer ${authToken}`,
                "X-Gloow-Domain-Data": domainPermissionToken,
            });
        super(axiosConfig);
    }
    /**
     *
     * @param q
     * @returns
     */
    globalSearch(q) {
        return this.get(`search/?${qs.stringify({ q })}`);
    }
    /**
     *
     * @param q
     * @returns
     */
    autocomplete(q) {
        return this.get(`search/autocomplete?${qs.stringify({ q })}`);
    }
}
exports.PhaethonApi = PhaethonApi;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhhZXRob25BcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJpdmF0ZS9hcGktc2VydmljZXMvcGhhZXRob25BcGkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsNEJBQTRCO0FBQzVCLHdDQUFrRDtBQUNsRCxrQ0FBaUM7QUFFakMseUNBQXFDO0FBQ3JDOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLFdBQWUsU0FBUSxrQkFBVTtJQUU1QyxZQUFZLE1BQWMsRUFBRSxTQUEyQixFQUFFLHFCQUF1QztRQUU5RixNQUFNLFdBQVcsR0FBdUI7WUFDdEMsT0FBTyxFQUFFLHNCQUFnQjtZQUN6QixPQUFPLEVBQUU7Z0JBQ1AsU0FBUyxFQUFFLE1BQU07YUFDbEI7WUFDRCxPQUFPLEVBQUUsS0FBSztTQUNmLENBQUM7UUFFRixJQUFJLFNBQVMsSUFBSSxxQkFBcUI7WUFDdEMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxXQUFXLENBQUMsT0FBTyxFQUFFO2dCQUM1QixhQUFhLEVBQUUsVUFBVSxTQUFTLEVBQUU7Z0JBQ3BDLHFCQUFxQixFQUFFLHFCQUFxQjthQUM3QyxDQUFDLENBQUE7UUFFRixLQUFLLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDckIsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxZQUFZLENBQUMsQ0FBUztRQUMzQixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsV0FBVyxFQUFFLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDcEQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxZQUFZLENBQUMsQ0FBUztRQUMzQixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsdUJBQXVCLEVBQUUsQ0FBQyxTQUFTLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUNoRSxDQUFDO0NBQ0Y7QUF0Q0Qsa0NBc0NDIn0=